<template>
  <div v-if="extendedProps" class="k-event" :class="extendedProps.is_dot_event ? 'dot-event' : ''">
    <span>
      <i v-if="extendedProps.is_dot_event && !isModuleEvent" class="fas fa-circle" aria-hidden="true"></i>
      <i v-if="extendedProps.is_dot_event && isModuleEvent" :class="`fa-duotone ${moduleEventIcon}`" aria-hidden="true"></i>
      <span class="dot-event-time" v-if="extendedProps.is_dot_event">{{ arg.timeText }}</span>
      <b>{{ arg.event.title }}</b>
    </span>
  </div>
</template>

<style scoped>
.dot-event {
  padding-left: 5px;
  display: flex;
  align-items: baseline;
  flex-direction: column;
  overflow: hidden;
}

.dot-event > span {
  display: flex;
  align-items: center;
  gap: 5px;
}

.dot-event i.fas.fa-circle {
  font-size: 10px;
}

.dot-event .dot-event-time {
  color: var(--kate-type-light);
}

</style>

<script>

export default {
  props: {
    arg: Object,
  },

  computed: {
    extendedProps() {
      return this.arg?.event?.extendedProps;
    },

    isModuleStart() {
      return this.arg?.event?.extendedProps.event_type === 'module_start';
    },

    isModuleCompletion() {
      return this.arg?.event?.extendedProps.event_type === 'module_completion';
    },

    isModuleEvent() {
      return this.isModuleStart || this.isModuleCompletion;
    },

    moduleEventIcon() {
      if (this.isModuleStart) {
        return 'fa-duotone fa-hourglass-start';
      }
      return 'fa-duotone fa-hourglass-end';
    },
  },
};
</script>
